<div class="safety-container">

  <div class="safety-header">
    <img src="assets/images/PerfPointLogo.png" alt="Performance Point" class="logo" />
  </div>

  <div class="counters-row">

    <!-- OSHA Counter -->
    <div class="counter-card">
      <h2 class="counter-title">WE HAVE WORKED</h2>
      <div class="digit-row">
        <div class="digit-display" aria-label="Days counter">
          <span class="digit" *ngFor="let d of oshaDigits">{{ d }}</span>
        </div>
        <div class="days-label" aria-hidden="true">DAYS</div>
      </div>
      <p class="counter-subtitle">WITHOUT AN OSHA<br><a
          class="recordable-link"
          href="https://rhassets.s3.us-east-1.amazonaws.com/OSHA+recordables.pdf"
          target="_blank"
          rel="noopener noreferrer"
          title="What counts as an OSHA recordable incident (PDF)">RECORDABLE</a> INCIDENT</p>
      <p class="best-record">Best Record: {{ oshaBest }} days</p>
      <div class="controls" *ngIf="isAuthorized">
        <button class="btn-adjust" (click)="adjustCounter('osha', 'subtract')">-1</button>
        <button class="btn-reset" (click)="resetCounter('osha')">Reset</button>
        <button class="btn-adjust" (click)="adjustCounter('osha', 'add')">+1</button>
      </div>
    </div>

    <!-- Vehicle Counter -->
    <div class="counter-card">
      <h2 class="counter-title">Days Without a Preventable Vehicle Accident</h2>
      <div class="digit-row">
        <div class="digit-display" aria-label="Days counter">
          <span class="digit" *ngFor="let d of vehicleDigits">{{ d }}</span>
        </div>
        <div class="days-label" aria-hidden="true">DAYS</div>
      </div>
      <p class="best-record">Best Record: {{ vehicleBest }} days</p>
      <div class="controls" *ngIf="isAuthorized">
        <button class="btn-adjust" (click)="adjustCounter('vehicle', 'subtract')">-1</button>
        <button class="btn-reset" (click)="resetCounter('vehicle')">Reset</button>
        <button class="btn-adjust" (click)="adjustCounter('vehicle', 'add')">+1</button>
      </div>
      <p class="safety-link-row">
        <a class="safety-link"
           href="https://drive.google.com/drive/folders/1PgyxgdvX9VC6ZVnhwzpWPCsHt7wYLj66?usp=drive_link"
           target="_blank"
           rel="noopener noreferrer"
           title="Safety resources (Google Drive)">Safety Resources</a>
      </p>
    </div>

  </div>

  <div *ngIf="isAxisAuthorized" style="text-align: center; margin-top: 2em;">
    <button mat-raised-button color="primary" (click)="runAxisReconcile()" [disabled]="axisReconciling">
      {{ axisReconciling ? 'Reconciling...' : 'Run AXIS Reconciliation' }}
    </button>
  </div>

</div>
